// Does not render. Will be used by the `Tutorial` component
const Project = () => {
  return null;
};

export default Project;
